
import { Component } from '@angular/core';
import { OidcClientManagerService } from '../service-oidc/oidc-client-manager.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
    companyList: any[] = []; // Initialize companyList to an empty array
    selectedCompany: any = '';
    selectedCompanyData: any = null; // Initialize selectedCompanyData to nul
    constructor(private oidcClientManager: OidcClientManagerService, private http: HttpClient) {
        // Initialize OIDC client manager or any other services here
    }
    login() {
        const clientSettings = {
            // Add your required OIDC client settings here
            // client_id: 'b1-ext-0117680e-d806-4fc6-9501-6fb2f023ab0b', //localhost 3300
            client_id: 'b1-ext-7a025106-cd2c-4727-a9e1-0a3d5712a078', //erp.ubshanacloud.in
        };
        let sldAddress = "https://ubsdemo.ubshanacloud.in:40000/sld/sld0100.svc";
        // let slBaseUrl = "https://ubsdemo.ubshanacloud.in:50000/b1s/v2";

        this.oidcClientManager.init(clientSettings, sldAddress + '/GetOpenIDConnectProvider', sldAddress + '/CurrentUserInfo')
            .then(() => {
                this.oidcClientManager.getBindingCompaniesInfo()
                    .then((companyList: any) => {
                        // Call your UI binding function here, e.g.:
                        // this.bindCompanyListUI(companyList);
                        console.log("Company List:", companyList);
                        this.companyList = companyList.d.CurrentUserInfo.B1UserBindings.results; // Store the company list in the component property
                    })
                    .catch((err: any) => {
                        alert("get binding user info failed: " + err);
                    });
            })
            .catch((err: any) => {
                if (err.message === "access_denied") {
                    alert("Current user does not have permission to access company");
                    this.oidcClientManager.startSignoutRedirect();
                } else {
                    alert(err);
                }
            });

    }
    // Add login logic here if needed
    onCompanyChange(data: any) {
        console.log("Company change event data:", data);
        console.log("Company changed:", data?.CompanyID);
        sessionStorage.setItem("companyID", data?.CompanyID || '');
        const selectedCompany = data?.CompanyID;
        console.log("Company changed:", selectedCompany);
        if (selectedCompany) {
            this.selectedCompany = selectedCompany;
            this.chooseCompanyForm(selectedCompany);
        } else {
            console.warn("Selected company not found in companyList");
        }
    }

    chooseCompanyForm(companyID: string) {
        var compData = this.companyList.find((company: any) => company.CompanyID === companyID);
        this.selectedCompanyData = compData; // Store the selected company data
        console.log("Selected company data:", this.selectedCompanyData);
        console.log("Company data:", compData);
    }

    getEntitiestest(name: string) {
        const companyID = sessionStorage.getItem("companyID");
        if (!companyID) {
            alert("No companyID found in sessionStorage");
            return;
        }
        const slBaseUrl = "https://ubsdemo.ubshanacloud.in:50000/b1s/v2/";
        const settings = {
            headers: {
                "x-b1-companyid": encodeURIComponent(companyID),
            }
        };
        this.oidcClientManager.ajaxHelper(slBaseUrl + name + '?$top=1', settings)
            .then((data: any) => {
                console.log(JSON.stringify(data));
            })
            .catch((error: any) => {
                console.log(JSON.stringify(error));
            });
    }


    getEntities(name: string) {
        const companyID = sessionStorage.getItem("companyID");
        if (!companyID) {
            alert("No companyID found in sessionStorage");
            return;
        }
        const slBaseUrl = "https://ubsdemo.ubshanacloud.in:50000/b1s/v2/";
        const url = `${slBaseUrl}${name}?$top=1`;
        const headers: Record<string, string> = {
            "x-b1-companyid": encodeURIComponent(companyID)
        };

        // Get access token from oidcClientManager
        this.oidcClientManager.getAccessToken().then((accessToken: string) => {
            if (accessToken) {
                headers['Authorization'] = `Bearer ${accessToken}`;
            }
            headers['Content-Type'] = 'application/json';
            this.http.get(url, { headers }).subscribe({
                next: (data) => {
                    console.log(JSON.stringify(data));
                },
                error: (error) => {
                    console.log(JSON.stringify(error));
                }
            });
        }).catch((err: any) => {
            console.error('Failed to get access token:', err);
        });
    }


}

